export default {"src":"/_next/static/media/Social_tiktok.2c7e1513.svg","height":7043,"width":7043,"blurWidth":0,"blurHeight":0};